import { render, staticRenderFns } from "./TrainingAsignmentModal.vue?vue&type=template&id=4829b156&scoped=true"
import script from "./TrainingAsignmentModal.vue?vue&type=script&lang=ts"
export * from "./TrainingAsignmentModal.vue?vue&type=script&lang=ts"
import style0 from "./TrainingAsignmentModal.vue?vue&type=style&index=0&id=4829b156&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4829b156",
  null
  
)

export default component.exports